import grammar from './grammar.json';


export const GRAMMAR_M10 = [
  ...grammar
];